module.exports = __webpack_public_path__ + "static/media/Sanomat Grab Web-XBold Italic.aa0b5a50.eot";